module.exports = __webpack_public_path__ + "static/img/label-06.874122e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-06.png
// module id = W7aT
// module chunks = 150